import React from 'react';
import {
  InstantSearch as ReactInstantSearch,
  InstantSearchProps as ReactInstantSearchProps,
} from 'react-instantsearch-hooks';
import { searchClient } from 'algolia/searchClient';
import { cachedProductsSearchClient } from 'algolia/cachedProductsSearchClient';

type Props = Partial<ReactInstantSearchProps> & {
  /** PLP-only: preload the full product dataset once and answer filter/sort/pagination locally. */
  cacheProducts?: boolean;
};

// Algolia Insights event tracking (Filter Applied / Hits Viewed / click & conversion events,
// posted to insights.algolia.io) is intentionally disabled. With locally-cached PLP results
// these events get attributed to stale/shared queryIDs, so the search-attributed analytics
// (CTR, per-query conversion, re-ranking, A/B) are not meaningful. Re-add InsightsMiddleware
// here to turn tracking back on.
const InstantSearch: React.FC<Props> = ({ indexName, cacheProducts, children, ...props }) => (
  <ReactInstantSearch
    searchClient={cacheProducts ? cachedProductsSearchClient : searchClient}
    indexName={indexName as string}
    {...props}
  >
    {children}
  </ReactInstantSearch>
);

export default InstantSearch;
